import { createTheme } from "@mui/material/styles";
import theme from "@/styles/scss/theme.module.scss";

const Palette = () => {
  return createTheme({
    palette: {
      mode: "light",
      heart: {
        light: theme.heart,
        main: theme.heart,
        dark: theme.heart,
        contrastText: theme.white,
      },
      olive: {
        light: theme.olive,
        main: theme.olive,
        dark: theme.olive,
        contrastText: theme.white,
      },
      roots: {
        light: theme.roots,
        main: theme.roots,
        dark: theme.roots,
        contrastText: theme.white,
      },
      ocean: {
        light: theme.ocean,
        main: theme.ocean,
        dark: theme.ocean,
        contrastText: theme.white,
      },
      sunlight: {
        light: theme.sunlight,
        main: theme.sunlight,
        dark: theme.sunlight,
        contrastText: theme.primaryMain,
      },
      common: {
        black: theme.black,
      },
      primary: {
        light: theme.primaryLight,
        main: theme.primaryMain,
        dark: theme.primaryDark,
      },
      secondary: {
        light: theme.secondaryLight,
        main: theme.secondaryMain,
        dark: theme.secondaryDark,
      },
      white: {
        light: theme.white,
        main: theme.white,
        dark: theme.white,
        contrastText: theme.black,
      },
      black: {
        light: theme.black,
        main: theme.black,
        dark: theme.black,
        contrastText: theme.white,
      },
      error: {
        light: theme.errorLight,
        main: theme.errorMain,
        dark: theme.errorDark,
      },
      warning: {
        light: theme.warningLight,
        main: theme.warningMain,
        dark: theme.warningDark,
      },
      success: {
        light: theme.successLight,
        main: theme.successMain,
        dark: theme.successDark,
      },
      grey: {
        50: theme.grey50,
        100: theme.grey100,
        200: theme.grey200,
        300: theme.grey300,
        400: theme.grey400,
        500: theme.grey500,
        600: theme.grey600,
        700: theme.grey700,
        800: theme.grey800,
        900: theme.grey900,
      },
      text: {
        primary: theme.primaryMain,
        secondary: theme.grey600,
      },
      divider: theme.grey600,
      background: {
        paper: theme.backgroundColor,
        // eslint-disable-next-line quote-props
        default: theme.backgroundColor,
      },
    },
  });
};

export default Palette;
